const state = {
  language: 'ES',
  contact_modal: false,
  date_modal: false,
  professional_modal: false,
  loader: false,
  current_services: [],
  content_slider: false,
  loader: false,
  contact_modal: false
}

const getters = {
  getLanguage (state) {
    return state.language
  },
  getContactModal (state) {
    return state.contact_modal
  },
  getDateModal (state) {
    return state.date_modal
  },
  getProfessionalModal (state) {
    return state.professional_modal
  },
  getLoader (state) {
    return state.loader
  },
  getCurrentServices (state) {
    return state.current_services
  },
  getContentSlider (state) {
    return state.content_slider
  },
  getLoader (state) {
    return state.loader
  }
}

const mutations = {
  setLanguage: function (state, payload) {
    state.language = payload
  },
  setContactModal: function (state, payload) {
    state.contact_modal = payload
  },
  setDateModal: function (state, payload) {
    state.date_modal = payload
  },
  setProfessionalModal: function (state, payload) {
    state.professional_modal = payload
  },
  setLoader: function (state, payload) {
    state.loader = payload
  },
  setCurrentServices: function (state, payload) {
    state.current_services = payload
  },
  setContentSlider: function (state, payload) {
    state.content_slider = payload
  },
  setLoader: function (state, payload) {
    state.loader = payload
  }
}

const actions = {
  updateLanguage: function ({commit}, payload) {
    commit('setLanguage', payload)
  },
  updateContactModal: function ({commit}, payload) {
    commit('setContactModal', payload)
  },
  updateDateModal: function ({commit}, payload) {
    commit('setDateModal', payload)
  },
  updateProfessionalModal: function ({commit}, payload) {
    commit('setProfessionalModal', payload)
  },
  updateLoader: function ({commit}, payload) {
    commit('setLoader', payload)
  },
  updateCurrentServices: function ({commit}, payload) {
    commit('setCurrentServices', payload)
  },
  updateContentSlider: function ({commit}, payload) {
    commit('setContentSlider', payload)
  },
  updateLoader: function ({commit}, payload) {
    commit('setLoader', payload)
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/vue/store/modules/session.js